var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStocks = function SvgStocks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 98,
    viewBox: "0 0 143 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M3.84863 5.36719H139.035",
    stroke: "#A9C0FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M3.84863 28.0977H139.035",
    stroke: "#A9C0FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M3.84863 50.8145H139.035",
    stroke: "#A9C0FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M3.84863 73.5449H139.035",
    stroke: "#A9C0FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M3.84863 96.2617H139.035",
    stroke: "#A9C0FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.72852 96.2622C1.72852 96.2622 11.3172 73.5443 23.3606 73.5443C35.4156 73.5443 37.6053 50.8263 52.3916 50.8263C67.178 50.8263 64.17 73.5443 74.5769 73.5443C84.9838 73.5443 92.1062 28.0968 108.541 28.0968C124.975 28.0968 137.572 5.37891 137.572 5.37891",
    stroke: "#ED5B39",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M142 5.09994C142 7.3696 140.172 9.19988 137.929 9.19988C135.686 9.19988 133.858 7.3696 133.858 5.09994C133.858 2.83028 135.686 1 137.929 1C140.182 1 142 2.82879 142 5.09994Z",
    fill: "#F8F9FA",
    stroke: "#0552BC",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1418 52.0999C50.1418 54.3696 48.3138 56.1999 46.0709 56.1999C43.828 56.1999 42 54.3696 42 52.0999C42 49.8303 43.828 48 46.0709 48C48.3238 48 50.1418 49.8288 50.1418 52.0999Z",
    fill: "#F8F9FA",
    stroke: "#0552BC",
    strokeWidth: 2
  })));
};
export default SvgStocks;